import React from 'react';
import { arrayOf, func, number, oneOfType, shape, string } from 'prop-types';
import { Col, Select } from 'antd';
import { filterOption, formatTitle } from './utils';
import styles from './styles';

const DropdownFilter = ({
  defaultValue,
  name,
  onSetFilter,
  options,
  placeholder,
  title,
  valueMember = 'ID',
}) => {
  const handleChange = React.useCallback(
    value => onSetFilter(name, value),
    [name, onSetFilter]
  );

  const formattedOptions = React.useMemo(
    () =>
      options.map(o => ({
        key: o.ID,
        label: o.Description,
        value: o[valueMember],
      })),
    [options, valueMember]
  );

  return (
    <Col xxl={6} xl={8} lg={12} xs={24} style={styles.filter}>
      <span className="grid-filter-label">{formatTitle(title)}</span>
      <Select
        allowClear
        showSearch
        style={styles.filterInput}
        placeholder={formatTitle(placeholder)}
        filterOption={filterOption}
        onChange={handleChange}
        defaultValue={defaultValue}
        options={formattedOptions}
      />
    </Col>
  );
};

DropdownFilter.propTypes = {
  defaultValue: string,
  name: string,
  onSetFilter: func,
  options: arrayOf(
    shape({
      Description: string,
      ID: number,
    })
  ),
  placeholder: oneOfType([string, arrayOf(string)]),
  title: oneOfType([string, arrayOf(string)]),
};

export default DropdownFilter;
